import { IUser } from '@/utils/types/User';
import { IGameItem } from '@/utils/types/Items';

export interface ICoinflipPendingJoin {
    source: 'STEAM' | 'BOT';
    expiresAt: number;
    botJoinAt?: number | null;
    user: Pick<IUser, 'id' | 'name' | 'avatar' | 'experience'>;
}

export interface ICoinflipGame {
    id: number;

    firstUser: IUser;
    firstSide: ECoinflipSide;
    firstItems: IGameItem[];

    secondUser?: IUser;
    secondSide: ECoinflipSide;
    secondItems: IGameItem[];

    pendingJoin?: ICoinflipPendingJoin | null;

    winnerSide?: ECoinflipSide;

    endsAt?: number | null;
    flipStartAt?: number | null;
    revealAt?: number | null;
    clearAt?: number | null;

    createdAt: Date;

    hash: string;
    secret?: string;
}

export interface ICoinflipHistoryGame {
    id: number;

    winnerSide: ECoinflipSide;

    itemsAndUsersIds: Record<string, number[]>;
    prizeUsd: number;
    chancePercent: number;

    hash: string;
    secret: string;
    tickets: number;

    createdAt: Date;
    updatedAt: Date;

    winnerUser: IUser;
    loserUser: IUser;

    skins: Record<number, IGameItem[]>;
}
export enum ECoinflipSide {
    FIRST = 1,
    SECOND = 2,
}
